import { RouterProvider } from "react-router";
import { Toaster } from "sonner";
import { adminRouter } from "./routes/admin";

export default function AdminApp() {
  return (
    <>
      <RouterProvider router={adminRouter} />
      <Toaster position="top-center" richColors />
    </>
  );
}
